export default function frontMatter(string) {
  if (!string) {
    return { attributes: {}, body: "" };
  }
  const match = /^---\r?\n([\s\S]*?)\r?\n---\r?\n([\s\S]*)$/.exec(string);
  if (!match) {
    return { attributes: {}, body: string };
  }
  const attributes = {};
  match[1].split(/\r?\n/).forEach((line) => {
    const colonIndex = line.indexOf(":");
    if (colonIndex !== -1) {
      const key = line.slice(0, colonIndex).trim();
      const value = line.slice(colonIndex + 1).trim();
      attributes[key] = value;
    }
  });
  return { attributes, body: match[2] };
}
